import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClassFromExist } from 'class-transformer';
import { Result, ResultList, SingleResult } from '../models';
import { GetOfficeEquipmentTypesInput, OfficeEquipmentTypeInput, OfficeEquipmentTypeResult } from '../models/office-equipment-type';
import { Utility } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class OfficeEquipmentTypeService {

  constructor(private httpClient: HttpClient) { }

  public addOfficeEquipmentType(officeEquipmentTypeInput: OfficeEquipmentTypeInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentType/AddOfficeEquipmentType', officeEquipmentTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editOfficeEquipmentType(id: number, officeEquipmentTypeInput: OfficeEquipmentTypeInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'OfficeEquipmentType/EditOfficeEquipmentType?id=' + id, officeEquipmentTypeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteOfficeEquipmentType(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'OfficeEquipmentType/DeleteOfficeEquipmentType?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getOfficeEquipmentType(id: number): Promise<SingleResult<OfficeEquipmentTypeResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'OfficeEquipmentType/GetOfficeEquipmentType?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<OfficeEquipmentTypeResult>(OfficeEquipmentTypeResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<OfficeEquipmentTypeResult>(OfficeEquipmentTypeResult), result.error));
  }

  public getOfficeEquipmentTypes(getOfficeEquipmentTypesInput: GetOfficeEquipmentTypesInput): Promise<ResultList<OfficeEquipmentTypeResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipmentType/GetOfficeEquipmentTypes', getOfficeEquipmentTypesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OfficeEquipmentTypeResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OfficeEquipmentTypeResult>(), result.error));
  }
}
